import type { Participant } from 'types'

// Default ordering: Archived last, then Participant Group, then Reference, then
// Name. Uses Intl.Collator to handle numeric sorting of references (e.g. CP/2 <
// CP/10).
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
const compareStrings = (a?: string, b?: string): number => collator.compare(a ?? '', b ?? '')

const isArchived = (participant: Participant): boolean => !participant.active

export const sortParticipants = (data: Participant[]): Participant[] =>
  [...data].sort((a, b) =>
    Number(isArchived(a)) - Number(isArchived(b)) ||
    compareStrings(a.participantGroup?.name, b.participantGroup?.name) ||
    compareStrings(a.reference, b.reference) ||
    compareStrings(a.name, b.name)
  )
